import React, {useState, useEffect, useContext, useMemo} from "react";

import Select from 'react-select';
import Swal from 'sweetalert2'

import './ChecklistRegistrados.css';

//import ChecklistRegistradosList from "../../components/checklistList/ChecklistRegistradosList";

import controlContext from "../../context/control/controlContext.js"
import checklistContext from "../../context/checklistContext/checklistContext";
import ChecklistRegList from "../../components/checklistRegList/ChecklistRegList";
import authContext from "../../context/authentication/authContex";
import usuariosContext from "../../context/usuarios/usuariosContext";
import { ALERTSProcedimientosProgramados, CHECKLISTStates, STATES, TIPPROCS } from "../../utils/states";
import FilterScreen from "../../components/filterScreen/FilterScreen";
import AddFilter from "../../components/addFilter/AddFilter";
import SearchInput from "../../components/searchInput/SearchInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

const ChecklistRegistrados = () =>{

    const location = useLocation();
    const ckContext = useContext(checklistContext)
    const {actualizarChecklistRegList, checklistRegList, iniciarFiltrosChecklistRegs, filtrosRango, filtrosEstado, modificarFiltrosRango, modificarFiltrosEstado, cargandoChecklistRegs, filtrarChecklistRegistrados, initialState} = ckContext;

    const auContext = useContext(authContext);
    const { usuario } = auContext;

    const uContext = useContext(usuariosContext);
    const {userListView} = uContext

    const {iniciarFiltros} = useContext(controlContext);

    const [CKtoFind,setCKtoFind] = useState(localStorage.getItem('CKtoFind') || location?.state?.CKtoFind || null);
    const wSpaceFromActivos = localStorage.getItem('workspaceSelected');
    const checklistsRegFromLocalStorage = useMemo(() => localStorage.getItem('checklistsReg'), []);

    const [checklistsFiltrados, setChecklistsFiltrados] = useState((checklistsRegFromLocalStorage && checklistsRegFromLocalStorage != 'null') ? JSON.parse(checklistsRegFromLocalStorage) : undefined);
    const [loading,setLoading] = useState((checklistsRegFromLocalStorage && checklistsRegFromLocalStorage != null) ? false : true);
    const [filter,setFilter] = useState(CKtoFind != null ? CKtoFind : '');
    const [showFilters,setShowFilter] = useState(false);
    const [select,setSelect] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [filterTipoActivos,setFilterTipoActivos] = useState([]);
    const [activeWorkSpace, setActiveWorkSpace] = useState((wSpaceFromActivos == null ) ? {todos: 1, vencidos: 0, porVencer:0 } : {todos: (wSpaceFromActivos == 'todos') ? 1 : 0, vencidos: (wSpaceFromActivos == 'vencidos') ? 1 : 0, porVencer: (wSpaceFromActivos == 'porVencer') ? 1 : 0});

   
    const handleWorkSpace = async(statusToDisplay) =>{
        let workspaceToSet = (statusToDisplay == 'todos') ? {todos: 1, ctrlFallidos: 0} : {todos: 0, ctrlFallidos: 1}
        setActiveWorkSpace(workspaceToSet);
        let STATESChecklist = (statusToDisplay == 'todos') ? ['CTRLFALLIDOS', 'CTRLEXITOSOS'] : ['CTRLFALLIDOS'];
        const filterEstado = {...filtrosEstado, statesChecklist: STATESChecklist};
        const filterRango = initialState.filtrosRango;
        aplicarFiltros({filterRango, filterEstado},'');
    }

    const aplicarFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    const handlerInicializarFiltros = async () => {
        const state = STATES;
        const tipoAlerta = ALERTSProcedimientosProgramados;
        //let statesProcs = (statusToDisplay != null) ? (statusToDisplay == 'todos') ? ['PEND','PROG','COMPL'] : ['PEND','PROG'] : ['PEND','PROG','COMPL'];
        let statesProcs = ['PEND','PROG','COMPL'];
        await iniciarFiltros(state, usuario, tipoAlerta, TIPPROCS, 'consumos', statesProcs);
    }

    useEffect(()=>{
        handlerInicializarFiltros();
        //Si checklistRegList se cargo previamente loading se setea a falso y al traer los nuevos datos, si es que los tiene, los mostrara.
        if(localStorage.getItem('CKtoFind')) localStorage.removeItem('CKtoFind');
        
        if(checklistsRegFromLocalStorage != null && checklistsRegFromLocalStorage != 'null'){
            setChecklistsFiltrados(JSON.parse(checklistsRegFromLocalStorage));
            // localStorage.removeItem("checklistsReg");
            setLoading(false);
        }
    },[])

    useEffect(()=>{
        //Si los checklists recibidos desde ProcsProgramadosList al clickear en VerCK llega en nulo, traer los checklists normalmente, sino omitir accion.
        let ckFiltradosToSet;
        
        if(checklistsRegFromLocalStorage && checklistsRegFromLocalStorage != 'null' && !checklistRegList) ckFiltradosToSet = filtrarChecklistRegistrados(JSON.parse(checklistsRegFromLocalStorage), filtrosEstado, filtrosRango);
        else ckFiltradosToSet = filtrarChecklistRegistrados(checklistRegList, filtrosEstado, filtrosRango)

        setChecklistsFiltrados(ckFiltradosToSet);
        setLoading(false);
    },[checklistRegList,filtrosEstado,filtrosRango]);

    return <div className="checklistRegView">
        <div className="utilitiesDiv">
            <FilterScreen verFiltro={setShowFilter}/>
            {cargandoChecklistRegs && <FontAwesomeIcon icon={faSpinner} pulse className="rrIcon loadingReqList" id="progIcon"/>}
            <SearchInput filter={filter} buscar={setFilter}/>
        </div>
        <div className="handleWorkSpaceDiv">
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'todos' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("todos")}>TODOS</label>
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'ctrlFallidos' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("ctrlFallidos")}>CON CONTROLES FALLIDOS</label>
        </div>
        {!checklistsFiltrados ? <h3 className='warningStatusMsg'>
            Cargando<span>.</span><span>.</span><span>.</span>
        </h3> : (checklistsFiltrados.length == 0) ? <h3 className="warningStatusMsg">No hay registros de checklists cargados</h3> : <ChecklistRegList checklistRegList={checklistsFiltrados} filter={filter}/>
        }
        {showFilters &&
        <div className="filterContainer">
            <AddFilter
            usuarios={userListView} item={selectedFilter} 
            cerrar={setShowFilter} filtro={{filtrosRango, filtrosEstado}} aplicarFiltros={aplicarFiltros} 
            workspace={activeWorkSpace} selct={select} setSelec={setSelect} filterTipoActivos={filterTipoActivos} setFilterTipoActivos={setFilterTipoActivos} componentePadre="ChecklistReg"/>
        </div>
        }
    </div>

}

export default ChecklistRegistrados;